import { Grid } from '@mui/material';
import React from 'react';

import history from 'Lib/browserHistory';
import { useAppSelector } from 'Reducers/store/hooks';
import { getAllMappedAccountByAccountId } from 'Selectors/accounts';
import { getFirmByFirmId } from 'Selectors/firms';

import FirmAccountDetailsHeader from './firmAccountDetailsHeader';
import FirmAccountWallets from './firmAccountWallets';
import { FIRM_VIEW_ACCOUNTS_TAB } from '../..';

import { FirmAccountDetailsProps } from '.';

export function FirmAccountDetails(props: FirmAccountDetailsProps) {
    const {
        classes,
        match
    } = props;

    const firmId = match.params.firmId;
    const firm = useAppSelector((state) => getFirmByFirmId(state, firmId));
    const mappedAccount = useAppSelector((state) => getAllMappedAccountByAccountId(state, match.params.accountId));
    const { account } = mappedAccount;

    React.useEffect(() => {
        if (!account) {
            history.push(`/admin/firms/${firmId}`, { tab: FIRM_VIEW_ACCOUNTS_TAB });
        }
    }, [ account, firmId ]);

    if (!account) return <div />;

    return (
        <Grid
            className={classes.root}
            container
            direction='column'
            spacing={0}
            wrap='nowrap'
        >
            <FirmAccountDetailsHeader
                firm={firm}
                mappedAccount={mappedAccount}
            />
            <Grid
                className={classes.accountAdditionalInfoContainer}
                container
                direction='row'
                justifyContent='flex-start'
                spacing={0}
                wrap='wrap'
            >
                <Grid
                    className={classes.accountUsersPanel}
                    item
                    xs={6}
                >
                    <FirmAccountWallets
                        account={account}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
}